import FieldDropdown from "../../dropdown/dropdown"
import FieldConfig from "../../../proto/field-config";
import {ConditionType_Excludes, ConditionType_Includes} from "../../../../model2/conditions/condition-types";

export default class FieldDateRelative extends FieldDropdown {

    constructor(config:FieldConfig) {

        config.showMenuMore = false

        super(config);

        this.conditionTypes     = [ConditionType_Includes, ConditionType_Excludes]

        // special
        this.options            = []

        for(let i = -90; i <= -2; i++) this.options.push({value: i, label: '{0} days ago'.f(Math.abs(i))})
        this.options.push({value: -1, label: 'Yesterday'})
        this.options.push({value: 0, label: 'Today'})

        // days after (pastdue)
        this.options.push({value: 1, label: 'Tomorrow'})
        for (let i = 2; i <= 90; i++) this.options.push({value: i, label: '+{0} days'.f(i)})

        this.noValueOption      = false
        this.isSearchable       = false

    }

}